var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCatalogFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 120,
    viewBox: "0 0 114 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 5.42529C0.75 2.83642 2.84869 0.737793 5.4375 0.737793H108.588C112.451 0.737793 114.656 5.14804 112.338 8.23817L86.3113 42.9329L112.338 77.6275C114.656 80.7175 112.451 85.1281 108.588 85.1281L10.125 85.125V114.812C10.125 117.185 8.36156 119.146 6.07356 119.456L5.4375 119.499C3.06437 119.499 1.10319 117.736 0.792813 115.448L0.75 114.812V5.42529Z",
    fill: "#13559F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalogFlag);
export default __webpack_public_path__ + "static/media/catalog-flag.221bd60a766335617ecdf6a2c20cb749.svg";
export { ForwardRef as ReactComponent };